import { ReactNode } from 'react'

import {
  IconDefinition,
  faCircleExclamation,
  faClipboardList,
  faFileLines,
  faListCheck,
  faFolder,
  faHouse,
  faMap,
  faSquareDashed,
} from '@fortawesome/pro-regular-svg-icons'

export enum UniversalSearchOptionType {
  Address,
  Parcel,
  Other,
  Record,
  Violation,
  Condition,
  PlanPage,
}

export const UniversalSearchOptionTypeToIconDefinitionMap: Record<
  UniversalSearchOptionType,
  IconDefinition
> = {
  [UniversalSearchOptionType.Address]: faHouse,
  [UniversalSearchOptionType.Parcel]: faSquareDashed,
  [UniversalSearchOptionType.Other]: faMap,
  [UniversalSearchOptionType.Record]: faFolder,
  [UniversalSearchOptionType.Violation]: faCircleExclamation,
  [UniversalSearchOptionType.Condition]: faListCheck,
  [UniversalSearchOptionType.PlanPage]: faFileLines,
}

export const ChildRecordIcon: IconDefinition = faClipboardList

export type UniversalSearchOption = {
  type: UniversalSearchOptionType
  title: string
  subtitle: ReactNode
  subtitleSortString: string
  url: string
  uuid: string
  isChildRecord?: boolean
  parentUuid?: string
}

export type UniversalSearchType = {
  label: string
  mode:
    | 'all'
    | 'addresses'
    | 'conditions'
    | 'otherLayer'
    | 'parcels'
    | 'planPages'
    | 'records'
    | 'violations'
  recordTypeId?: number
  entityLayerId?: number
}
